import { ECountries, ECountryCode } from '../enums/country-code.enum';
import IMAGES from './images';

export const COUNTRIES = [
    {
        value: ECountries.EC,
        flag: IMAGES.countries.ec_flag,
    },
    {
        value: ECountries.MX,
        flag: IMAGES.countries.mx_flag,
    },
    {
        value: ECountries.CO,
        flag: IMAGES.countries.co_flag,
    },
    {
        value: ECountries.PE,
        flag: IMAGES.countries.pe_flag,
    },
];

export const COUNTRY_CODES = {
    [ECountries.EC]: ECountryCode.EC,
    [ECountries.MX]: ECountryCode.MX,
    [ECountries.CO]: ECountryCode.CO,
    [ECountries.PE]: ECountryCode.PE,
};
